import React from 'react';
import { useLocation } from 'react-router-dom';
import SimpleTabs from '../../../components/tabs/simpleTabs';
import GoogleTabIcon from '../../../assets/icons/tab/google-tab-icon.svg';
import BingTabIcon from '../../../assets/icons/tab/bing-tab-icon.svg';
import LinkedInTabIcon from '../../../assets/icons/tab/linkedInTabIcon.svg';
import TiktokIcon from '../../../assets/icons/tab/logo-tic-tok.svg';
import { AdProvidersTabLinks } from '../../../components/enums/tabEnums';
import metaIcon from '../../../assets/icons/tab/integrationsMetaIcon.png';
import SnapchatIcon from '../../../assets/icons/tab/logo-snapchat.svg';

const Integrations = () => {
  const location = useLocation();
  const activePanel = AdProvidersTabLinks[location.pathname.split('/').pop() as keyof typeof AdProvidersTabLinks] || 0;

  return (
    <div className="h-full rounded-lg border border-dark bg-white px-6 py-4">
      <SimpleTabs
        currentTab={activePanel}
        tabs={[
          {
            tabLabel: 'Google',
            href: 'google',
            identifierName: 'google-panel',
            icon: GoogleTabIcon,
          },
          {
            tabLabel: 'Meta',
            href: 'facebook',
            identifierName: 'facebook-panel',
            icon: metaIcon,
          }, {
            tabLabel: 'Bing',
            href: 'bing',
            identifierName: 'bing-panel',
            icon: BingTabIcon,
          },
          {
            tabLabel: 'LinkedIn',
            href: 'linked-in',
            identifierName: 'linked-in',
            icon: LinkedInTabIcon,
          },
          {
            tabLabel: 'TikTok',
            href: 'tik-tok',
            identifierName: 'tik-tok',
            icon: TiktokIcon,
          },
          {
            tabLabel: 'Snapchat',
            href: 'snapchat',
            identifierName: 'snapchat',
            icon: SnapchatIcon,
          },
        ]}
      />
    </div>
  );
};

export default Integrations;
